<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { getStoredUser, getStoredUserId } from "@/helpers/sessionHelper";

export default {
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Informasi Pegawai",
      items: [
        {
          text: "Informasi Pegawai",
          active: true,
        },
      ],
      pegawai: {
        user_id: null,
        jenis_pegawai: localStorage.getItem("user_pegawai") || "pegawai_internal",
        username: null,
        nama: null,
        jabatan: null,
        unit: null,
        status: 1,
        last_login: null,
        created_at: null,
        updated_at: null,
      },
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    fullDateTimeFormat(datetime) {
      if (!datetime) return "-";
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },

    loadFromSession() {
      const stored = getStoredUser();
      if (stored) {
        this.populatePegawaiData(stored);
        return true;
      }
      return false;
    },

    populatePegawaiData(data) {
      if (!data) return;
      const uid = data.idpegawai_internal ?? data.id ?? null;
      if (uid && String(uid) !== "null" && String(uid) !== "undefined") {
        this.pegawai.user_id = String(uid);
      }
      this.pegawai.username =
        data.u_nip || data.username || this.pegawai.username;
      this.pegawai.nama = data.nama || data.name || this.pegawai.nama;
      this.pegawai.jabatan = data.jabatan || this.pegawai.jabatan;
      this.pegawai.unit =
        data.u_namaunit1 || data.u_unitlev2 || data.unit || this.pegawai.unit;
      if (data.active_flag !== undefined && data.active_flag !== null) {
        this.pegawai.status = Number(data.active_flag);
      }
      this.pegawai.last_login = data.last_login || this.pegawai.last_login;
      this.pegawai.created_at = data.created_at || this.pegawai.created_at;
      this.pegawai.updated_at = data.updated_at || this.pegawai.updated_at;
    },

    async getData() {
      // 1. Tampilkan data dari session/cache lokal secara instan (zero-delay)
      const hasLocalData = this.loadFromSession();

      // 2. Dapatkan user_id yang valid dari session
      const userId = getStoredUserId() || this.pegawai.user_id;

      // JIKA user_id null/undefined/kosong, jangan pernah tembak API master/users-pegawai/null!
      if (!userId || userId === "null" || userId === "undefined") {
        console.warn(
          "[informasi-pegawai] User ID pegawai tidak tersedia di session, menggunakan data profil lokal.",
        );
        return;
      }

      this.pegawai.user_id = String(userId);

      // 3. Hanya tampilkan blocking loader jika data lokal sama sekali belum ada
      const needBlockingLoader = !hasLocalData && !this.pegawai.username;
      if (needBlockingLoader) {
        Swal.fire({
          title: '<i class="fas fa-spinner fa-spin"></i>',
          text: "Loading...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });
      }

      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/users-pegawai/" +
            encodeURIComponent(userId),
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const resData = response.data?.data;
        if (resData) {
          this.populatePegawaiData(resData);

          // Perbarui cache localStorage agar tetap sinkron
          try {
            localStorage.setItem("user", JSON.stringify(resData));
            if (resData.idpegawai_internal) {
              localStorage.setItem(
                "session_user_id",
                String(resData.idpegawai_internal),
              );
            }
          } catch (e) {
            // ignore
          }
        }
      } catch (err) {
        console.warn(
          "[informasi-pegawai] Gagal mengambil profil terbaru dari server:",
          err,
        );
      } finally {
        if (needBlockingLoader) {
          Swal.close();
        }
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title mb-4">Foto Profil Akun Anda</h4>
              </div>
              
              <div class="col-md-12">
                <center>
                  <div class="position-relative mb-2">
                    <img
                      src="@/assets/images/users/avatar-9.png"
                      alt="Foto Profil Akun"
                      class="img-thumbnail"
                      style="width: 50%"
                    />
                  </div>

                  <h5 class="font-size-15 text-truncate">
                    {{ pegawai.username }}
                  </h5>
                  <p class="text-muted mb-0 text-truncate">
                    {{ pegawai.jenis_pegawai }}
                  </p>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title mb-4">Data Profil Akun Anda</h4>
              </div>
              
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-nowrap mb-0">
                    <tbody>
                      <tr>
                        <th scope="row" style="width: 20%">Username</th>
                        <td>{{ pegawai.username || "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Nama</th>
                        <td>{{ pegawai.nama || "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Roles</th>
                        <td>
                          <span v-if="pegawai.jenis_pegawai == 'pegawai_internal'">Pegawai Internal</span>
                          <span v-else-if="pegawai.jenis_pegawai == 'pegawai_eksternal'">Pegawai Eksternal</span>
                          <span v-else>{{ pegawai.jenis_pegawai || "Pegawai Internal" }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Jabatan</th>
                        <td>{{ pegawai.jabatan || "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Unit</th>
                        <td>{{ pegawai.unit || "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Status Akun</th>
                        <td>
                          <div v-if="pegawai.status == 1">
                            <div
                              class="badge badge-pill badge-soft-success font-size-12"
                            >
                              ENABLE
                            </div>
                          </div>
                          <div v-else>
                            <div
                              class="badge badge-pill badge-soft-danger font-size-12"
                            >
                              DISABLE
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Terakhir Login ke Aplikasi</th>
                        <td>{{ fullDateTimeFormat(pegawai.last_login) }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Waktu Pembuatan Akun</th>
                        <td>{{ fullDateTimeFormat(pegawai.created_at) }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Waktu Perubahan Data Terakhir</th>
                        <td>{{ fullDateTimeFormat(pegawai.updated_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
  </Layout>
</template>
